import React from 'react';
import qs from 'qs';
import PropTypes from 'prop-types';
import { Droppable, Draggable } from 'react-beautiful-dnd';

import Container from '#/elevate/containers/Container/Container';
import ContainerWrapper from '#/containers/IntuitiveEditor/components/ContainerWrapper';
import { NOOP } from '#/utils/general';
import getResolution from '#/utils/getResolution';

const { width, height } = getResolution();

const ContainerPage = ({
  containerConfig,
  containers,
  isUsingEditor,
  isEditionDisabled,
  location,
  onContainerClick,
  onContainerWrapperArrowClick,
  onContainerWrapperRemoveClick,
  onItemClick,
  selectedEditorEntry
}) => {
  const query = qs.parse((location.search || '').replace(/^\?/, ''));

  if (query.mode === 'edit') {
    return (
      <Droppable droppableId="containerPage">
        {providedTop => (
          <div
            style={{ minHeight: 600 }}
            {...providedTop.droppableProps}
            ref={providedTop.innerRef}
          >
            {(containers || []).map((container, index) => {
              return (
                <Draggable
                  draggableId={`${container.id}x`}
                  index={index}
                  isDragDisabled={isEditionDisabled}
                  key={container.id}
                >
                  {provided => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      onClick={() => onContainerClick(container)}
                      key={container.id}
                    >
                      <ContainerWrapper
                        container={container}
                        shouldHaveTopArrow={index !== 0 && !isEditionDisabled}
                        shouldHaveBottomArrow={
                          index < containers.length - 1 && !isEditionDisabled
                        }
                        onContainerWrapperArrowClick={
                          onContainerWrapperArrowClick
                        }
                        onContainerWrapperRemoveClick={
                          onContainerWrapperRemoveClick
                        }
                        selectedEditorEntry={selectedEditorEntry}
                      >
                        <Container
                          {...container}
                          isUsingEditor={isUsingEditor}
                          onItemClick={onItemClick}
                          selectedEditorEntry={selectedEditorEntry}
                          containerConfig={containerConfig}
                          index={index}
                        />
                      </ContainerWrapper>
                    </div>
                  )}
                </Draggable>
              );
            })}
            {providedTop.placeholder}
          </div>
        )}
      </Droppable>
    );
  }

  return (
    <div
      style={{
        width: width,
        height: height,
        position: 'relative'
      }}
    >
      {(containers || []).map(container => {
        return (
            <Container
              {...container}
              containerConfig={containerConfig}
              onItemClick={onItemClick}
            />
        );
      })}
    </div>
  );
};

ContainerPage.propTypes = {
  containerConfig: PropTypes.object,
  containers: PropTypes.array,
  isUsingEditor: PropTypes.bool,
  isEditionDisabled: PropTypes.bool,
  location: PropTypes.object,
  onContainerClick: PropTypes.func,
  onContainerWrapperArrowClick: PropTypes.func,
  onContainerWrapperRemoveClick: PropTypes.func,
  onItemClick: PropTypes.func,
  selectedEditorEntry: PropTypes.object
};

ContainerPage.defaultProps = {
  onContainerClick: NOOP
};

export default ContainerPage;
